import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { BuildHeader } from 'src/Utils/headerBuilder'
import { RequestMethods } from '../Helper/FetchHelpers'

const initialState = () => {
  return {
    Wrappers: null,
    Emails: null,
    SendEmailError: null,
    SendEmailSuccess: false,
  }
}

export const GetWrapper = createAsyncThunk('GetWrapper', async (Login, password) => {
  var raw = JSON.stringify(Login)

  var requestOptions = {
    method: 'GET',
    headers: BuildHeader(),
    body: raw,
    // redirect: "follow",
  }

  const response = await fetch(
    window.extended.MYAPP_API_ENDPOINT + '/Template/' + 'GetWappers',
    requestOptions,
  )
  if (!response.ok) {
    const res = await response.text()
    throw new Error(res)
  }

  const formattedResponse = await response.json()
  return formattedResponse
})

export const UpdateWrapper = createAsyncThunk('UpdateWrapper', async (data) => {
  var raw = JSON.stringify(data)
  var requestOptions = {
    method: RequestMethods.POST,
    headers: BuildHeader(),
    body: raw,
    // redirect: "follow",
  }

  const response = await fetch(
    window.extended.MYAPP_API_ENDPOINT + '/Template/UpdateTemplateWrapper',
    requestOptions,
  )

  if (!response.ok) {
    const res = await response.json()
    console.log('res', res)
    throw new Error(res)
  }

  const formatttedResponse = await response.json()
  return formatttedResponse
})

export const GetEmailWrapper = createAsyncThunk('GetEmailWrapper', async (Login, password) => {
  var raw = JSON.stringify(Login)

  var requestOptions = {
    method: 'GET',
    headers: BuildHeader(),
    body: raw,
    // redirect: "follow",
  }

  const response = await fetch(
    window.extended.MYAPP_API_ENDPOINT + '/Template/' + 'GetEmails',
    requestOptions,
  )
  if (!response.ok) {
    const res = await response.text()
    throw new Error(res)
  }

  const formattedResponse = await response.json()
  return formattedResponse
})

export const UpdateEmailTemplate = createAsyncThunk('UpdateEmailTemplate', async (data) => {
  var raw = JSON.stringify(data)
  var requestOptions = {
    method: RequestMethods.POST,
    headers: BuildHeader(),
    body: raw,
    // redirect: "follow",
  }

  const response = await fetch(
    window.extended.MYAPP_API_ENDPOINT + '/Template/UpdateEmailTemplate',
    requestOptions,
  )

  if (!response.ok) {
    const res = await response.json()
    console.log('res', res)
    throw new Error(res)
  }

  const formatttedResponse = await response.json()
  return formatttedResponse
})

export const InsertEmailTemplate = createAsyncThunk('InsertEmailTemplate', async (data) => {
  var raw = JSON.stringify(data)
  var requestOptions = {
    method: RequestMethods.POST,
    headers: BuildHeader(),
    body: raw,
    // redirect: "follow",
  }

  const response = await fetch(
    window.extended.MYAPP_API_ENDPOINT + '/Template/InsertEmailTemplate',
    requestOptions,
  )

  if (!response.ok) {
    const res = await response.json()
    console.log('res', res)
    throw new Error(res)
  }

  const formatttedResponse = await response.json()
  return formatttedResponse
})

export const DeleteEmailTemplate = createAsyncThunk(
  'DeleteEmailTemplate',
  async (id, { rejectWithValue }) => {
    const requestOptions = {
      method: RequestMethods.DELETE,
      headers: BuildHeader(),
    }
    const response = await fetch(
      window.extended.MYAPP_API_ENDPOINT +
        `/Template/DeleteEmailTemplate?Id=${encodeURIComponent(id)}`,
      requestOptions,
    )
    if (response.status === 409) {
      const body = await response.json()
      return rejectWithValue({ blocked: true, blockedBy: body?.blockedBy, id })
    }
    if (!response.ok) {
      const text = await response.text()
      return rejectWithValue({ blocked: false, message: text, id })
    }
    return id
  },
)

export const SendEmailTemplate = createAsyncThunk(
  'SendEmailTemplate',
  async (templateGuid, { rejectWithValue }) => {
    var requestOptions = {
      method: RequestMethods.POST,
      headers: BuildHeader(),
      // redirect: "follow",
    }

    try {
      const response = await fetch(
        window.extended.MYAPP_API_ENDPOINT +
          '/EmailTest/SendEmailWithTemplate?emailId=' +
          templateGuid,
        requestOptions,
      )

      if (!response.ok) {
        const errorText = await response.text()
        return rejectWithValue(errorText)
      }

      const formattedResponse = await response.json()
      return formattedResponse
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to send test email')
    }
  },
)

const TemplatesSlice = createSlice({
  name: 'Templates',
  initialState,
  reducers: {
    ClearSendEmailSuccess: (state) => {
      state.SendEmailSuccess = false
    },
    ClearSendEmailError: (state) => {
      state.SendEmailError = null
    },
  },
  extraReducers: {
    [GetWrapper.pending]: (state) => {
      state.isLoading = true
    },
    [GetWrapper.fulfilled]: (state, action) => {
      console.log('GetTemplates.fulfilled')
      state.Wrappers = action.payload
    },
    [GetWrapper.rejected]: (state, action) => {},

    [UpdateWrapper.pending]: (state) => {
      state.isLoading = true
    },
    [UpdateWrapper.fulfilled]: (state, action) => {
      console.log('GetTemplates.fulfilled')
      // state.Wrappers = action.payload
    },
    [UpdateWrapper.rejected]: (state, action) => {},

    [GetEmailWrapper.pending]: (state) => {
      state.isLoading = true
    },
    [GetEmailWrapper.fulfilled]: (state, action) => {
      console.log('GetEmailWrapper.fulfilled')
      state.Emails = action.payload
    },
    [GetEmailWrapper.rejected]: (state, action) => {},

    [InsertEmailTemplate.pending]: (state) => {
      state.isLoading = true
    },
    [InsertEmailTemplate.fulfilled]: (state, action) => {
      console.log('InsertEmailTemplate.fulfilled')
      state.Emails = [...state.Emails, action.payload]
    },
    [InsertEmailTemplate.rejected]: (state, action) => {},

    [UpdateEmailTemplate.pending]: (state) => {
      state.isLoading = true
    },
    [UpdateEmailTemplate.fulfilled]: (state, action) => {
      const index = state.Emails.findIndex((x) => x.id === action.payload.id)
      if (index !== -1) {
        state.Emails[index] = action.payload
      }
    },
    [UpdateEmailTemplate.rejected]: (state, action) => {},

    [SendEmailTemplate.pending]: (state) => {
      state.isLoading = true
      state.SendEmailError = null
      state.SendEmailSuccess = false
    },
    [SendEmailTemplate.fulfilled]: (state, action) => {
      state.isLoading = false
      state.SendEmailError = null
      state.SendEmailSuccess = true
    },
    [SendEmailTemplate.rejected]: (state, action) => {
      state.isLoading = false
      state.SendEmailError = action.payload || 'Unknown error occurred'
      state.SendEmailSuccess = false
    },

    [DeleteEmailTemplate.fulfilled]: (state, action) => {
      if (state.Emails) {
        state.Emails = state.Emails.filter((e) => e.id !== action.payload)
      }
    },
    [DeleteEmailTemplate.rejected]: (state, action) => {},
  },
})

export const { ClearSendEmailSuccess, ClearSendEmailError } = TemplatesSlice.actions

export default TemplatesSlice.reducer
